export default "__VITE_ASSET__C26JgApv__"